export const API_BASE_URL = `${process.env.REACT_APP_RISK_MANAGEMENT_API_ENDPOINT}api`